import axios from "axios";
export function sendMailOrder(postData) {
   
    return axios.post('https://2yhrka7axi.execute-api.us-west-2.amazonaws.com/prod/contactus', postData)
    // return fetch(awsLambdUrl+'/sendmail?subject='+subject+'&mail_text='+mail_text+'&to='+to, {
    //method: 'POST',
}
//! Image Upload URL
const imageUploadURL =
    "https://ro8g0r0jp0.execute-api.ap-south-1.amazonaws.com/";
    export function UploadImage(image, path, bucket) {
        // console.log(bucket,"qqqqqqqqqqqqqqqqqqqqqqqqqqq");
        // console.log(bucket,"wwwwwwwwwwwwwwwwwwwwwwwwwwwwwww");
        // console.log(path,"eeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee");
        
        
        // const bucket = value
        //   ? process.env.REACT_APP_s3BucketRelianceAddressPath
        //   : process.env.REACT_APP_PurpleHealthS3bucket;
        
        const url = `${imageUploadURL}newUpload?bucket=${bucket}&bucketPath=${path}`;
      
        return axios
          .post(url, image)
          .then((res) => res.data) // Return the response data directly
          .catch((err) => {
            console.error("Error uploading image:", err); // Log the error
            throw err; // Rethrow the error so the calling function can handle it
          });
      }
// export function UploadImage(image,path,value) {
//     return axios
//         .post(
//             `${imageUploadURL}newUpload?bucket=${value?process.env.REACT_APP_s3BucketRelianceAddressPath:process.env.REACT_APP_PurpleHealthS3bucket}&bucketPath=${path}`,
//             image
//         )
//         .then((data) => data)
//         .then((res) => res);
// }